import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/css/iconfont.css'
import '@/assets/css/animate.css'
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/css/style.css'
import i18n from '@/language'
import { getSiteSettings } from '@/services/content'



// --------
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
 
NProgress.configure({
  minimum: 0.2, // 进度条最小百分比
  
  template: `
    <div class="bar" role="bar">
      <div class="peg"></div>
    </div>
    <div class="spinner" role="spinner">
      <div class="spinner-icon"></div>
    </div>
  ` // 自定义进度条样式
})
 
// 在路由器导航守卫中使用NProgress
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
 
function setMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', name)
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', content || '')
}

async function applySiteSettings() {
  try {
    const settings = await getSiteSettings(i18n.locale)
    if (settings && settings.title) document.title = settings.title
    if (settings) {
      setMeta('keywords', settings.keywords)
      setMeta('description', settings.description)
    }
  } catch (error) {}
}

router.afterEach((to) => {
  NProgress.done()
  if (to.name !== 'NewsDetail') applySiteSettings()
})
// -------


Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
